import { render, staticRenderFns } from "./DocumentsSort.vue?vue&type=template&id=8116881c&scoped=true&"
import script from "./DocumentsSort.vue?vue&type=script&lang=ts&"
export * from "./DocumentsSort.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentsSort.vue?vue&type=style&index=0&id=8116881c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8116881c",
  null
  
)

export default component.exports